﻿﻿import { TicketVisibility } from '../../enums/index';
import { MessageType } from '../../enums/index';

export interface ITicketMessageRequest {
    id: number;
    ticketId: number;
    parentMessageId: number;
    createdDateTime: string;
    visibility: TicketVisibility;
    subject: string;
    message: string;
    from: string;
    to: string;
    cc: string[];
    bcc: string[];
    type: MessageType;
    files: File;
}
